import { Pipe, PipeTransform } from '@angular/core';
import { SavedViewsService } from '../saved-views.service';

/**
 * Deserializes a saved view name by removing the grid name prefix.
 *
 * This is a standalone pipe that can be imported directly into any component.
 * The SavedViewsService stores view names with a grid prefix (e.g., "CUSTOMERS_GRID__My View")
 * to allow the same view name across different grids. This pipe removes that prefix for display.
 *
 * Usage:
 *   Import in your component:
 *   import { DeserializeViewNamePipe } from '@/app/modules/saved-views/pipes/deserialize-view-name.pipe';
 *
 *   Add to component imports array:
 *   @Component({
 *     imports: [DeserializeViewNamePipe, ...],
 *     ...
 *   })
 *
 *   Use in template:
 *   {{ serializedViewName | deserializeViewName }}
 *
 * Example:
 *   {{ 'CUSTOMERS_GRID__Revenue Report' | deserializeViewName }}
 *   outputs: "Revenue Report"
 */
@Pipe({
  name: 'deserializeSavedViewName',
  standalone: true,
})
export class DeserializeSavedViewNamePipe implements PipeTransform {
  constructor(private savedViewsService: SavedViewsService) {}

  transform(serializedName: string): string {
    if (!serializedName) {
      return '';
    }
    return this.savedViewsService.deserializeViewName(serializedName);
  }
}
